export interface Vendor {
    ClientKey?: string;
    Id: string;
    VendorName: string;
}
